"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Typography_1 = require("../Typography");
const style = __importStar(require("./styled"));
const Theme_1 = require("../../../Theme");
const Checkbox_1 = __importDefault(require("../Checkbox"));
const Button_1 = __importDefault(require("../../Button"));
const Types_1 = require("Types");
const RangeInput_1 = __importDefault(require("../RangeInput/RangeInput"));
const Filter = ({ label, items, activeFilters, setActiveFilters, isLast, isLiteratureFilter, fromValue, setFromValue, toValue, setToValue }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [isRange, setIsRange] = (0, react_1.useState)(false);
    const itemsHasResults = items === null || items === void 0 ? void 0 : items.length;
    const toggleActive = (item, checked) => {
        if (checked) {
            setActiveFilters(prev => {
                return [...prev, item];
            });
        }
        else {
            setActiveFilters(prev => prev === null || prev === void 0 ? void 0 : prev.filter(e => e.id !== item.id));
        }
    };
    (0, react_1.useEffect)(() => {
        if ((activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length) > 0) {
            items.forEach(item => {
                if (activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.some(filter => filter.id === item.id)) {
                    setIsOpen(true);
                }
            });
        }
    }, [activeFilters]);
    (0, react_1.useEffect)(() => {
        var _a;
        if ((_a = items === null || items === void 0 ? void 0 : items[0]) === null || _a === void 0 ? void 0 : _a.isRange) {
            setIsRange(true);
        }
    }, [items]);
    return itemsHasResults ? (react_1.default.createElement(style.Container, { isLast: isLast },
        react_1.default.createElement(style.Row, { onClick: () => setIsOpen(!isOpen) },
            react_1.default.createElement(Button_1.default, { variant: Types_1.ButtonVariants.ONLY_TEXT },
                react_1.default.createElement(style.FilterLabel, { type: Typography_1.Types.EYEBROW_SMALL }, label)),
            react_1.default.createElement(style.Chevron, { stroke: Theme_1.theme.palette.BW_0, isOpen: isOpen })),
        isOpen && (react_1.default.createElement(style.ItemsRow, { isRange: isRange }, isRange ? (react_1.default.createElement(RangeInput_1.default, { min: items[0].min, max: items[0].max, fromValue: fromValue, toValue: toValue, setFromValue: setFromValue, setToValue: setToValue })) : (items.map(item => (react_1.default.createElement("div", { key: item.id },
            react_1.default.createElement(Checkbox_1.default, { name: item.name, checked: activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.some(e => e.id === item.id), label: item.name, value: item.name, results: item.results, onChange: e => toggleActive(item, e.target.checked), disabled: isLiteratureFilter ? item.results === 0 : false, isFilter: true }))))))))) : null;
};
exports.default = Filter;
